import { reactive } from 'vue'

interface ImgItem {
    [proName: string]: {
        Type: string,
        img: string
    };
}

const typeImgs: ImgItem = {
    ".cda": { Type: "音频", img: require('@/assets/img/new/file_audio.png') },
    ".wav": { Type: "音频", img: require('@/assets/img/new/file_audio.png') },
    ".mp3": { Type: "音频", img: require('@/assets/img/new/file_audio.png') },
    ".aif": { Type: "音频", img: require('@/assets/img/new/file_audio.png') },
    ".aiff": { Type: "音频", img: require('@/assets/img/new/file_audio.png') },
    ".mid": { Type: "音频", img: require('@/assets/img/new/file_audio.png') },
    ".wma": { Type: "音频", img: require('@/assets/img/new/file_audio.png') },
    ".ra": { Type: "音频", img: require('@/assets/img/new/file_audio.png') },
    ".vqf": { Type: "音频", img: require('@/assets/img/new/file_audio.png') },
    ".ape": { Type: "音频", img: require('@/assets/img/new/file_audio.png') },
    ".avi": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    ".wmv": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    ".mpeg": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    ".mp4": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    ".m4v": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    ".mov": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    ".asf": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    ".flv": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    ".f4v": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    ".rmvb": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    ".rm": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    ".3gp": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    ".vob": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    ".jpg": { Type: "图片", img: require('@/assets/img/new/file_picture.png') },
    ".jpeg": { Type: "图片", img: require('@/assets/img/new/file_picture.png') },
    ".bmp": { Type: "图片", img: require('@/assets/img/new/file_picture.png') },
    ".gif": { Type: "图片", img: require('@/assets/img/new/file_picture.png') },
    ".png": { Type: "图片", img: require('@/assets/img/new/file_picture.png') },
    ".tiff": { Type: "图片", img: require('@/assets/img/new/file_picture.png') },
    ".svg": { Type: "图片", img: require('@/assets/img/new/file_picture.png') },
    ".pdf": { Type: "PDF", img: require('@/assets/img/new/file_pdf.png') },
    ".xls": { Type: "Excel", img: require('@/assets/img/new/file_xlsx.png') },
    ".xlsx": { Type: "Excel", img: require('@/assets/img/new/file_xlsx.png') },
    ".doc": { Type: "Word", img: require('@/assets/img/new/file_word.png') },
    ".docx": { Type: "Word", img: require('@/assets/img/new/file_word.png') },
    ".ppt": { Type: "Word", img: require('@/assets/img/new/file_ppt.png') },
    ".pptx": { Type: "Word", img: require('@/assets/img/new/file_ppt.png') },
    ".txt": { Type: "文本", img: require('@/assets/img/new/file_txt.png') },
    "cda": { Type: "音频", img: require('@/assets/img/new/file_audio.png') },
    "wav": { Type: "音频", img: require('@/assets/img/new/file_audio.png') },
    "mp3": { Type: "音频", img: require('@/assets/img/new/file_audio.png') },
    "aif": { Type: "音频", img: require('@/assets/img/new/file_audio.png') },
    "aiff": { Type: "音频", img: require('@/assets/img/new/file_audio.png') },
    "mid": { Type: "音频", img: require('@/assets/img/new/file_audio.png') },
    "wma": { Type: "音频", img: require('@/assets/img/new/file_audio.png') },
    "ra": { Type: "音频", img: require('@/assets/img/new/file_audio.png') },
    "vqf": { Type: "音频", img: require('@/assets/img/new/file_audio.png') },
    "ape": { Type: "音频", img: require('@/assets/img/new/file_audio.png') },
    "avi": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    "wmv": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    "mpeg": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    "mp4": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    "m4v": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    "mov": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    "asf": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    "flv": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    "f4v": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    "rmvb": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    "rm": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    "3gp": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    "vob": { Type: "视频", img: require('@/assets/img/new/file_video.png') },
    "jpg": { Type: "图片", img: require('@/assets/img/new/file_picture.png') },
    "jpeg": { Type: "图片", img: require('@/assets/img/new/file_picture.png') },
    "bmp": { Type: "图片", img: require('@/assets/img/new/file_picture.png') },
    "gif": { Type: "图片", img: require('@/assets/img/new/file_picture.png') },
    "png": { Type: "图片", img: require('@/assets/img/new/file_picture.png') },
    "tiff": { Type: "图片", img: require('@/assets/img/new/file_picture.png') },
    "svg": { Type: "图片", img: require('@/assets/img/new/file_picture.png') },
    "pdf": { Type: "PDF", img: require('@/assets/img/new/file_pdf.png') },
    "xls": { Type: "Excel", img: require('@/assets/img/new/file_xlsx.png') },
    "xlsx": { Type: "Excel", img: require('@/assets/img/new/file_xlsx.png') },
    "doc": { Type: "Word", img: require('@/assets/img/new/file_word.png') },
    "docx": { Type: "Word", img: require('@/assets/img/new/file_word.png') },
    "ppt": { Type: "Word", img: require('@/assets/img/new/file_ppt.png') },
    "pptx": { Type: "Word", img: require('@/assets/img/new/file_ppt.png') },
    "txt": { Type: "文本", img: require('@/assets/img/new/file_txt.png') },
    "default": { Type: "其他", img: require('@/assets/img/new/file_other.png') }
}




// 获取文件图片
function getFileTypeImg(extension: string): string {
    const current: any = typeImgs[extension] || typeImgs.default
    return current.img
}

export default getFileTypeImg